const CONSTANTS = require('frontend-controller/lib/constants');
const utils = require('frontend-controller/lib/utils');
module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form',
	],

	config: {
		resourceConnected: false
	},

	methods: {
		getProperties(){
			let routeAttributes = this.getResourceRegisterContent('routeTreeParent') || {}
			const url = ((storage.app || {}).webService || {}).url
			this.locate('< base_tabStrip_tabStrip > templates_propertiesForms_routePropertiesForm', form => {
				routeAttributes = ((form.resourceData || {}).data || {}).attributes || routeAttributes
			})

			return {
				url,
				path: routeAttributes.path,
				routeID: routeAttributes.resourceID || routeAttributes.routeID || routeAttributes.id,
				routeAttributes,
			}
		},

		isBuildGranted(storage){
			if(storage.isServer){
				return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES
			}

			const {
				url,
				routeID,
			} = this.getProperties()

			if(url && routeID){
				return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES
			}

			return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.NO
		},

		open: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			const {
				url,
				path
			} = this.getProperties()

			if(url){
				if(path){
					window.open(url + path, '_blank').focus()
				} else {
					console.error('OPEN_ROUTE_PATH_MISSING')
				}
			} else {
				console.error('OPEN_ROUTE_WEB_SERVICE_MISSING')
			}
		},

		connectLanguage: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			const {
				routeID,
			} = this.getProperties()

			if(routeID) {
				return this.performAndStoreAction(
					`${baseActionKey}_inEffect`,
					this.prepareAction(baseActionKey, undefined, {
						routeLanguageConnector: {
							routeID
						}
					}),
					true
				)
			}

			return utils.promise.reject();
		},
	}
}